var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-marker',{attrs:{"lat-lng":_vm.latLng},on:{"click":_vm.clicked}},[_c('l-popup',{attrs:{"options":{maxWidth: 'auto'}}},[_c('PlacePopup',{attrs:{"placeId":_vm.placeId,"markerClicked":_vm.markerClicked}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }